import styled from "styled-components";

export const ContainerWrapper = styled.div`
 margin-top: 67px;
 display: grid;
 grid-template-columns:100%;
 width: 100%;
 margin-bottom: 70px;
 align-items: center;
 font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;

`
export const Image = styled.img`
    width: 98px;
    height: 98px;
    border-radius: 10px;
    border: 1px solid #c5c5c5;
    margin-right: 15px;
    @media (max-width:767px){
      margin-right: 0px;
    }
`
export const ADImage = styled.img`
    width: 668px;
    object-fit:contain;
    @media (max-width: 1524px) {
      width:95% !important;
    }  
    @media (max-width: 1124px) {
        width:90% !important;
      }  
`
export const H3 = styled.h3`
    color: #58595B;
    font-size: 0.91rem;
    margin-top: 12px;
    margin-right: 2px;
    font-weight: 600;
    font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    span{
        color:#2196F3;
    }
    @media (max-width: 1124px) {
        font-size: 12px !important;
      }  

    @media (max-width: 794px) {
        font-size: 10px !important;
      } 
`

export const GridHeader = styled.div`
  display: flex;
  background-color:#f9f9f9;
  min-height:100vh;
  padding-right: 50px;
  @media(max-width:990px){
    padding-right: 0px;
  }
`;
export const PharmacySidebar = styled.div`
  position: fixed;
  width:270px;
  left:0;
  z-index:9;
  mix-blend-mode: multiply;
  @media(max-width:990px){
    display:none !important;
  }
`;
export const PharmacyMainWraper = styled.div`
  width:100%;
  margin-left: 180px;
  padding-bottom: 50px;
  @media(max-width:990px){
    margin:0;
    padding : 40px 20px;
  }
`;